import { render, staticRenderFns } from "./Company_company.vue?vue&type=template&id=d2c474ec&scoped=true&lang=pug&"
import script from "./Company_company.vue?vue&type=script&lang=coffee&"
export * from "./Company_company.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c474ec",
  null
  
)

export default component.exports